<template>
  <main class="index-page">
    <div v-if="type || genre" class="breadcrumbs" itemscope itemtype="http://schema.org/BreadcrumbList">
      <div itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
        <nuxt-link to="/" itemprop="item">
          <span itemprop="name">Главная</span>
        </nuxt-link>
        <meta itemprop="position" content="1">
      </div>

      <div v-if="type" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
        <i class="icon-arrow" />
        <nuxt-link v-if="genre" :to="`/?type=${type}`" itemprop="item">
          <span itemprop="name">{{ type }}</span>
        </nuxt-link>
        <span v-else itemprop="name">{{ type }}</span>
        <meta itemprop="position" content="2">
      </div>

      <div v-if="genre" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
        <i class="icon-arrow" />
        <span itemprop="name">{{ genre }}</span>
        <meta itemprop="position" content="3">
      </div>
    </div>
    
    <section>
      <h1>
        Наше меню . {{ type ? `Аниме ${type}` : 'Аниме' }}{{ year ? ` (${year})` : '' }}{{ (genre || country) ? `:` : ' ' }}
        <template v-if="translation">{{ translation }}</template>
        <template v-if="translation && status">, </template>
        <template v-if="status">{{ status === 'ongoing' ? 'Онгоинги' : 'Завершенные' }}</template>
        <template v-if="status && genre">, </template>
        <template v-if="genre">{{ genre }}</template>
        <template v-if="genre && country">, </template>
        <template v-if="country">{{ country }}</template>
        <template v-if="sort">{{ sortH }}</template>
        <template v-if="page > 1"> - страница {{ page }}</template>
      </h1>

      <div v-if="isDesktop" class="filters">
        <div>
          <select name="type_filter" id="type_filter" v-model="type" @change="goTo()" class="custom-select">
            <option value="">Тип</option>
            <option value="movie">Movie</option>
            <option value="tv">TV</option>
            <!-- <option value="music">Music</option> -->
            <option value="special">Special</option>
            <option value="ova">OVA</option>
            <option value="ona">ONA</option>
          </select>
          <select name="type_status" id="type_status" v-model="status" @change="goTo()" class="custom-select">
            <option value="">Статус</option>
            <option value="ongoing">Онгоинги</option>
            <option value="released">Релизы</option>
          </select>
          <select name="translation" id="translation" v-model="translation" @change="goTo()" class="custom-select">
            <option value="">Озвучка</option>
            <option v-for="t in translations" :key="`filter-translation-${t}`" :value="t">{{ t }}</option>
          </select>
          <select name="genre_filter" id="genre_filter" v-model="genre" @change="goTo()" class="custom-select">
            <option value="">Жанр</option>
            <option v-for="g in genres" :key="`filter-genre-${g}`" :value="g">{{ g }}</option>
          </select>
          <select name="country_filter" id="country_filter" v-model="country" @change="goTo()" class="custom-select">
            <option value="">Страна</option>
            <option v-for="c in countries" :key="`filter-country-${c}`" :value="c">{{ c }}</option>
          </select>
          <select name="year_filter" id="year_filter" v-model="year" @change="goTo()">
            <option value="">
              Год
            </option>
            <option v-for="y in years" :key="y" :value="y">
              {{ y }}
            </option>
            <option v-for="d in decade" :key="d" :value="d">
              {{ d }}
            </option>
          </select>
          <div v-if="showReset" @click="reset" class="reset">
            <img src="/static_files/icons/reset.svg" alt="Reset">
            <span>Сбросить фильтр</span>
          </div>
        </div>
        <div class="sort">
          <select name="sort_filter" id="sort_filter" v-model="sort" @change="goTo()" class="custom-select">
            <option value="">Порядок</option>
            <option value="popular">По популярности</option>
            <option value="date">По новизне</option>
            <option value="rating">По рейтингу</option>
          </select>
        </div>
      </div>
      <div v-else-if="showFilters" class="filters">
        <div @click="showFilters = false" class="close"></div>
        <div>
          <select name="type_filter" id="type_filter" v-model="type" @change="goTo()" class="custom-select">
            <option value="">Тип</option>
            <option value="movie">Movie</option>
            <option value="tv">TV</option>
            <!-- <option value="music">Music</option> -->
            <option value="special">Special</option>
            <option value="ova">OVA</option>
            <option value="ona">ONA</option>
          </select>
          <select name="type_status" id="type_status" v-model="status" @change="goTo()" class="custom-select">
            <option value="">Статус</option>
            <option value="ongoing">Онгоинги</option>
            <option value="released">Релизы</option>
          </select>
          <select name="translation" id="translation" v-model="translation" @change="goTo()" class="custom-select">
            <option value="">Озвучка</option>
            <option v-for="t in translations" :key="`filter-translation-${t}`" :value="t">{{ t }}</option>
          </select>
          <select name="genre_filter" id="genre_filter" v-model="genre" @change="goTo()" class="custom-select">
            <option value="">Жанр</option>
            <option v-for="g in genres" :key="`filter-genre-${g}`" :value="g">{{ g }}</option>
          </select>
          <select name="country_filter" id="country_filter" v-model="country" @change="goTo()" class="custom-select">
            <option value="">Страна</option>
            <option v-for="c in countries" :key="`filter-country-${c}`" :value="c">{{ c }}</option>
          </select>
          <select name="year_filter" id="year_filter" v-model="year" @change="goTo()">
            <option value="">
              Год
            </option>
            <option v-for="y in years" :key="y" :value="y">
              {{ y }}
            </option>
            <option v-for="d in decade" :key="d" :value="d">
              {{ d }}
            </option>
          </select>
          <select name="sort_filter" id="sort_filter" v-model="sort" @change="goTo()" class="custom-select">
            <option value="">Порядок</option>
            <option value="popular">По популярности</option>
            <option value="date">По новизне</option>
            <option value="rating">По рейтингу</option>
          </select>
          <div v-if="showReset" @click="reset" class="reset">
            <img src="/static_files/icons/reset.svg">
            <span>Сбросить фильтр</span>
          </div>
        </div>
        <button @click="showFilters = false" class="filters-set">
          Применить
        </button>
      </div>
      <div v-else>
        <button @click="showFilters = true" class="filters-btn">
          <img src="/static_files/icons/filters.svg" alt="Filters" style="width:24px;height:24px;">
          <span>Фильтры <sup v-if="filtersCount">{{ filtersCount }}</sup></span>
        </button>
      </div>

      <div style="margin-bottom: 15px;">
        Найдено: {{ count }}
      </div>

      <div v-if="page > 1" class="show-more prev">
        <button @click="goTo(+page - 1)">
          Предыдущие ({{ +page - 1 }} стр.)
          <i v-if="!loading" class="arrow" />
          <i v-else class="loader" />
        </button>
      </div>

      <VideoComponent v-if="items.length" :videos="items" />

      <div v-if="!lastPage && items.length && items.length >= 24" class="show-more next">
        <button @click="goTo(+page + 1)">
          Показать еще ({{ +page + 1 }} стр.)
          <i v-if="!loading" class="arrow" />
          <i v-else class="loader" />
        </button>
      </div>

      <div class="desc">
        <p>Аниме {{type}} {{year}} онлайн бесплатно – находите лучшие аниме {{genre}} и наслаждайтесь просмотром без ограничений. В нашем каталоге собраны {{type}} из разных стран, включая {{country}}, с качественной озвучкой и субтитрами {{translation}}. Удобный поиск и сортировка {{sort}} помогут вам быстро выбрать подходящий тайтл, а обновления {{status}} позволят следить за самыми свежими релизами.</p>

        <p>Наш сайт предлагает удобный плеер, стабильную работу на всех устройствах и разнообразие жанров. Здесь есть всё: от динамичного экшена до трогательной романтики, от эпического фэнтези до психологических триллеров. Даже если у вас нет конкретных предпочтений, вы всегда сможете найти что-то интересное.</p>

        <p>Смотрите аниме {{year}} онлайн бесплатно, открывайте для себя новые истории, выбирайте удобный формат {{translation}} и наслаждайтесь просмотром без рекламы и регистрации. Оставайтесь с нами, чтобы первыми узнавать о новинках и культовых тайтлах!</p>
      </div>
    </section>
  </main>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
    VideoComponent: () => import('~/components/VideoComponent.vue'),
  },
  head() {
    const fullPath = `https://animeitochka.ru${
      this.type || this.status || this.translation || this.genre || this.country || this.page > 1 ? `?page=${this.page}` : ''
    }${
      this.type ? `&type=${this.type}` : ''
    }${
      this.status ? `&status=${this.status}` : ''
    }${
      this.translation ? `&translation=${this.translation}` : ''
    }${
      this.genre ? `&genre=${this.genre}` : ''
    }${
      this.country ? `&country=${this.country}` : ''
    }${
      this.year ? `&year=${this.year}` : ''
    }${
      this.sort ? `&sort=${this.sort}` : ''
    }`

    const title = `Смотрите меню лучших ${
      this.type ? `аниме ${this.type}` : 'аниме'
    } онлайн${
      this.year ? ` (${this.year})` : ''
    }${
      (this.genre || this.country) ? `:` : ''
    }${
      this.genre ? ` ${this.genre}` : ''
    }${
      (this.genre && this.country) ? `,` : ''
    }${
      this.country ? ` ${this.country}` : ''
    } в хорошем качестве бесплатно${
      this.status ? `. ${this.status === 'ongoing' ? 'Онгоинги' : 'Релизы'}` : ''
    }${
      this.translation ? `. Озвучка ${this.translation}` : ''
    }${
      this.sort ? this.sortH : ''
    }${
      this.page > 1 ? `. Страница ${this.page}` : ''
    }`

    const description = `Смотрите меню лучших ${
      this.type ? `аниме ${this.type}` : 'аниме'
    }${
      this.year ? ` (${this.year})` : ''
    }${
      (this.genre || this.country) ? `:` : ''
    }${
      this.genre ? ` ${this.genre}` : ''
    }${
      (this.genre && this.country) ? `,` : ''
    }${
      this.country ? ` ${this.country}` : ''
    } лучшего качества онлайн в разных озвучках совершенно бесплатно ${
      this.page > 1 ? `. Страница ${this.page}` : ''
    }${
      this.status ? ` - ${this.status === 'ongoing' ? 'Онгоинги' : 'Релизы'}` : ''
    }${
      this.translation ? ` - озвучка ${this.translation}` : ''
    }${
      this.sort ? this.sortH : ''
    }`

    return {
      title: title,
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: fullPath
        }
      ],
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: `${this.type ? `Аниме ${this.type} смотреть онлайн` : 'Аниме смотреть онлайн'}`
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: fullPath
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: description
        }
      ]
    }
  },
  watch: {
    sort(val) {
      if (val === 'date') {
        this.sortH = '. Самые новые'
      } else if (val === 'popular') {
        this.sortH = '. Самые популярные'
      } else if (val === 'rating') {
        this.sortH = '. Самые рейтинговые'
      }
    },
  },
  watchQuery: ['page', 'type', 'status', 'translation', 'genre', 'country', 'year', 'sort'],
  async asyncData({ query, $axios, error }) {
    const page = query.page ? query.page : 1
    const type = query.type ? query.type : ''
    const status = query.status ? query.status : ''
    const translation = query.translation ? query.translation : ''
    const genre = query.genre ? query.genre : ''
    const country = query.country ? query.country : ''
    const year = query.year ? query.year : ''
    const sort = query.sort ? query.sort : ''
    let sortH = ''

    let url = `/api/catalog?page=${encodeURIComponent(page)}`
    if (type) url += `&type=${encodeURIComponent(query.type)}`
    if (status) url += `&status=${encodeURIComponent(query.status)}`
    if (genre) url += `&genre=${encodeURIComponent(query.genre)}`
    if (country) url += `&country=${encodeURIComponent(query.country)}`
    if (translation) url += `&translation=${encodeURIComponent(query.translation)}`
    if (year) url += `&year=${encodeURIComponent(query.year)}`
    if (sort) {
      url += `&sort=${encodeURIComponent(query.sort)}`
      if (sort === 'date') {
        sortH = '. Самые новые'
      } else if (sort === 'rating') {
        sortH = '. Самые рейтинговые'
      } else if (sort === 'popular') {
        sortH = '. Самые популярные'
      }
    }

    const { data } = await $axios.get(url)

    if (data.error) {
      return error(data.error)
    }

    // const typeH =  {
    //   anime: 'Аниме',
    //   'anime-serial': 'Многосерийные аниме'
    // }

    const years = []
    for (let i = new Date().getFullYear(); i > 2020; i--) {
      years.push(i)
    }

    return {
      count: data.count,
      items: data.items,
      loading: false,
      showFullDesc: false,
      lastPage: false,
      years,
      decade: [
        '2020-2016',
        '2015-2011',
        '2010-2000',
        '2000-1990',
        '1990-1980',
        '1980-1970',
        '1970-1960'
      ],
      genres: ["Безумие","Боевые искусства","Вампиры","Военное","Гарем","Демоны","Детектив","Детское","Дзёсей","Драма","Игры","Исторический","Комедия","Космос","Магия","Машины","Меха","Музыка","Пародия","Повседневность","Полиция","Приключения","Психологическое","Романтика","Самураи","Сверхъестественное","Сейнен","Спорт","Супер сила","Сёдзё","Сёдзё-ай","Сёнен","Сёнен-ай","Триллер","Ужасы","Фантастика","Фэнтези","Хентай","Школа","Экшен","Этти","Яой"],
      countries: ['Россия', 'Япония', 'Китай', 'Корея Южная', 'Тайвань', 'Канада', 'Филиппины',],
      translations: [
        'SHIZA Project', 'AniStar', 'AniMaunt', 'Субтитры', 'AniLibria.TV', 'JAM', 'AnimeVost', 'Amazing Dubbing', 'Ушастая озвучка',
        'SovetRomantica', 'AniDUB', 'Studio Band', 'Animedia', 'Crunchyroll', 'HDrezka Studio', 'Ancord',
      ],
      page,
      status,
      translation,
      type,
      genre,
      year,
      country,
      sort,
      sortH,
      // typeH,
      showFilters: false,
      withTrailer: false
    }
  },
  computed: {
    ...mapState(['isDesktop']),
    filtersCount() {
      const obj = {}
      if (this.type) obj.type = this.type
      if (this.status) obj.status = this.status
      if (this.translation) obj.translation = this.translation
      if (this.genre) obj.genre = this.genre
      if (this.year) obj.year = this.year
      if (this.country) obj.country = this.country
      if (this.sort) obj.sort = this.sort
      return Object.keys(obj).length
    },
    showReset() {
      return this.type || this.translation || this.status || this.genre || this.country || this.year || this.sort
    },
  },
  methods: {
    reset() {
      this.page = 1
      this.status = ''
      this.translation = ''
      this.type = ''
      this.genre = ''
      this.country = ''
      this.year = ''
      this.sort = ''
      this.goTo()
    },
    goTo(page = 1) {
      let url = `/?page=${page}`
      if (this.status) url += `&status=${encodeURIComponent(this.status)}`
      if (this.translation) url += `&translation=${encodeURIComponent(this.translation)}`
      if (this.type) url += `&type=${encodeURIComponent(this.type)}`
      if (this.genre) url += `&genre=${encodeURIComponent(this.genre)}`
      if (this.country) url += `&country=${encodeURIComponent(this.country)}`
      if (this.year) url += `&year=${encodeURIComponent(this.year)}`
      if (this.sort) url += `&sort=${encodeURIComponent(this.sort)}`

      this.$router.push(url)
    },
  }
}
</script>

<style src="~/assets/index.styl" lang="stylus" />
